<app-side-insight [selectedSdk]='selectedSdk' [selectedDate]="selectedDate" [showInsight]='showInsight'
  [navigateTo]="navigateTo" (navCloseClick)='closeInsight()'>
</app-side-insight>

<div class="rankings-content-section">
  <div class="rankings-main-content">
    <div class="right-content rankings {{currentConfig?.key}}">
      <div class="main-content" [ngClass]="{'loading': loading, 'loadingData': loadingData}">
        <div class="d-flex justify-content-between rankings-heading rankings-header-level-1 flex-column flex-md-row">
          <img class="banner-bg" src="/assets/videos/sdk-index-title.gif" alt="Banner Background">
          <div class="banner-overlay"></div>
          <div class='d-flex flex-wrap align-items-center justify-content-between w-100 rankings-header-container'>
            <div class='rankings-header'>
              <h2 class="rankings-heading-title d-lg-block">
                {{currentConfig?.heading}}
              </h2>
              <div class="rankings-heading-subtitle">
                {{currentConfig?.subHeading}}
              </div>
            </div>
            <div class="d-flex flex-column banner-buttons">
              <a class="btn btn-primary" href="https://www.pixalate.com/sdk-trust-index" target="_blank">What is the
                SDK Trust Index<i class="fa fa-chevron-right ml-1"></i></a>
              <a class="btn btn-primary" href="https://www.pixalate.com/sdk-trust-index-methodology" target="_blank">SDK
                Trust Index Methodology<i class="fa fa-chevron-right ml-1"></i></a>
              <a class="btn btn-primary" href="https://www.pixalate.com/sdk-trust-index-evidence-dashboard"
                target="_blank">SDK
                Code Analysis Evidence<i class="fa fa-chevron-right ml-1"></i></a>
            </div>
          </div>
        </div>

        <div class="rankings-heading">
          <div class="disclaimer-content short-disclaimer">
            Disclaimer: Pixalate's Trust SDK Index Ratings reflect Pixalate's opinions and proprietary research
            findings, and are not intended to impugn the standing or reputation of any entity, person, or SDK.
            Classification of an SDK within a particular risk tier does not indicate that the operator, its SDK(s), or
            any associated practices are in violation of any laws or regulations, including COPPA, FTC Section 5, or any
            other global privacy framework. See full disclaimer below.
          </div>
          <div class="ranking-filter">
            <div
              class="filters-container w-100 d-flexalign-items-center justify-content-between flex-column flex-md-row">
              <div class="input-group search-input">
                <app-new-rankings-search-filter (searchEvent)="searchEvent($event)"></app-new-rankings-search-filter>
              </div>
              <app-new-rankings-main-filter-items [currentMainFilterItems]="currentMainFilterItems"
                [selectedGroup]="selectedGroup"
                (selectMainFilterClick)="selectMainFilter($event.mainFilterItem, $event.option)">
              </app-new-rankings-main-filter-items>
            </div>
          </div>
        </div>

        <div class='results-table-cont'>
          <ng-container *ngIf="desktop$ | async">
            <div class='results-table-scroll-cont' [ngClass]="{'d-none': noResult}" *ngIf="gridData?.length > 0">
              <table class='results-table' fixed-table-header [ngClass]="{ sortable: currentConfig?.sortable }"
                *ngIf="currentConfig?.gridHeaders as rankingGridHeaders">
                <thead>
                  <tr>
                    <ng-container *ngFor="let header of rankingGridHeaders; let last = last;">
                      <ng-container *ngIf="!header.hidden && gridData[0][header.key] &&
                         (currentConfig?.notHideDataIfNA || gridData[0][header.key] !== 'N/A')">
                        <ng-container *ngIf="header?.key !== 'spacer'; else spacer">
                          <th class="{{header?.key}}" (click)="toggleSort(header)">
                            <app-ranking-gridheader-widget-container [header]="header"
                              [widgetComponent]="header?.headerWidgetComponent" [selectedGroup]="selectedGroup"
                              [isLast]="last">
                            </app-ranking-gridheader-widget-container>
                            <div class="sort-buttons {{header?.sort}}" *ngIf="header?.sortColumnKey">
                              <i class="fa fa-caret-up"></i>
                              <i class="fa fa-caret-down"></i>
                            </div>
                          </th>
                        </ng-container>

                        <ng-template #spacer>
                          <th class="spacer" [style.width]="header?.format">&nbsp;</th>
                        </ng-template>
                      </ng-container>
                    </ng-container>
                  </tr>
                </thead>
                <tbody [ngClass]="{'show-results': !showAnonEmailUnlockForm}">
                  <tr class="table-row-nav"
                    *ngFor="let dataItem of gridData | filter: searchParamModel:'sdkName' | sortBy:sortHeader?.key:sortHeader?.sort; index as rowIdx"
                    (click)="openInsight(rowIdx, dataItem)">
                    <ng-container *ngFor=" let header of rankingGridHeaders; last as last">
                      <ng-container *ngIf="header?.key !== 'spacer'; else spacer">
                        <ng-container *ngIf="!header.hidden && gridData[0][header.key] &&
                         (currentConfig?.notHideDataIfNA || gridData[0][header.key] !== 'N/A')">
                          <td class="grid-data-item {{header.key}}">
                            <ng-container *ngIf="header?.widgetComponent">
                              <div [ngClass]="{'with-accordion': last}">
                                <app-ranking-widget-container [data]="dataItem" [header]="header"
                                  [reportId]="currentConfig?.reportId" [widgetComponent]="header.widgetComponent"
                                  [key]="header?.key" [format]="header.format" [selectedGroup]="selectedGroup"
                                  (clickEvent)="openInsight(rowIdx, dataItem, $event.key)">
                                </app-ranking-widget-container>
                                <i *ngIf="last" class="fa fa-chevron-right"></i>
                              </div>
                            </ng-container>
                          </td>
                        </ng-container>
                      </ng-container>
                      <ng-template #spacer>
                        <td>&nbsp;</td>
                      </ng-template>
                    </ng-container>
                  </tr>
                </tbody>
              </table>
            </div>
          </ng-container>

          <ng-container *ngIf="!(desktop$ | async)">
            <div class="d-flex flex-column" [ngClass]="{'d-none': noResult}" *ngIf="gridData?.length > 0">
              <ng-container *ngFor="let dataItem of gridData | filter: searchParamModel:'sdkName'; index as rowIdx">
                <div class="result-item-cont p-3 mx-0" *ngIf="currentConfig?.gridHeaders as rankingGridHeaders">
                  <ng-container *ngFor="let header of rankingGridHeaders">
                    <ng-container *ngIf="!header.hidden && gridData[0][header.key] &&
                         (currentConfig?.notHideDataIfNA || gridData[0][header.key] !== 'N/A')">
                      <div class="d-flex align-items-center justify-content-between result-item"
                        (click)="openInsight(rowIdx, dataItem)">
                        <span class="name" [innerHTML]="header.label | safehtml"></span>
                        <div class="value {{ header?.key }}">
                          <app-ranking-widget-container [data]="dataItem" [header]="header"
                            [reportId]="currentConfig?.reportId" [widgetComponent]="header.widgetComponent"
                            [key]="header?.key" [format]="header.format" [selectedGroup]="selectedGroup"
                            (clickEvent)="openInsight(rowIdx, dataItem, $event.key)">
                          </app-ranking-widget-container>
                        </div>
                      </div>
                    </ng-container>
                  </ng-container>
                </div>
              </ng-container>
            </div>
          </ng-container>

          <div class="load-more">
            <button [hidden]="!showLoadMore" class="btn btn-primary" (click)="loadMore()">
              <span>load more</span>
            </button>
            <button [hidden]="!showLoadingMore" class="btn btn-primary"> loading more results...</button>
            <span *ngIf="!loadingData && noResult" class="d-table mt-4 mx-auto">No results
              found.</span>
          </div>

          <div class="loader mt-5 mx-auto" data-loader="circle-side"></div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="disclaimer-content full-disclaimer" id="full-disclaimer">
  <p>
    <b>Disclaimer:</b> Pixalate’s SDK Trust Index Ratings (“SDK Index”) reflect Pixalate’s opinions that Pixalate
    believes may be useful to developers, regulators, platforms, advertisers, researchers, and others in the digital
    media industry. Any data shared is grounded in Pixalate’s proprietary technology and analytics, which Pixalate is
    continuously evaluating and updating. Any references to outside sources should not be construed as endorsements,
    affiliations, or associations with any third-parties. Pixalate is sharing this data not to impugn the standing or
    reputation of any entity, person or SDK, but, instead, to report research findings and trends pertaining to the
    period studied.
  </p>

  <p>It is important to note however, that classification of a software development kit operator (“SDK operator”) within
    a particular risk tier does not mean that the SDK operator, its SDK(s), or any associated practices are in violation
    of any laws or regulations, including the Children’s Online Privacy Protection Act (COPPA) or any other global
    privacy framework. Further, the SDK(s) of an SDK operator(s) that appear(s) to present elevated risk signals does
    not mean that such SDK, or its operator, is failing to comply with applicable FTC Rules.
  </p>

  <p>Pixalate’s determinations are based on a proprietary methodology that incorporates a combination of signals and
    automated processes. Additionally, with respect to SDK operators that appear to have characteristics that, in
    Pixalate’s opinion, may trigger related privacy law or regulatory compliance obligations and/or risk, such
    assertions reflect Pixalate’s opinions i.e., they are neither facts nor guarantees. While Pixalate endeavors to
    apply rigorous standards in compiling this SDK Index, no assurances or guarantees can be, or are, made as to the
    accuracy or completeness of any classification. This SDK Index, including all content set forth herein–constitutes
    Pixalate “Materials” under Pixalate’s Terms of Use, and is licensed subject to–and conditioned expressly
    upon–compliance with each of the applicable terms and conditions of such Pixalate Terms of Use.
  </p>

  <p>Apple and the Apple logo are trademarks of Apple Inc; Google, Google Ad Exchange, the brand “Google Play,” its
    logos, and other Google logos are trademarks of Google LLC. These companies are not affiliated with, nor do they
    endorse or sponsor, any products, data, content, reports, materials or services associated with Pixalate. Any other
    brand logos, names, or trademarks not explicitly mentioned herein – but otherwise mentioned, displayed, or used in
    any of Pixalate’s materials, including this report – are the property of their respective owners.
  </p>

  <p>© 2026 Pixalate, Inc.</p>

</div>

<app-rankings-anon-form-v2 [formTitle]="currentConfig.title"
  (formSubmit)="toggleTableBlur()"></app-rankings-anon-form-v2>